export default __webpack_public_path__ + "static/media/heat-map.76fc809c.svg";